



















import {Component, Inject, Prop, Vue} from 'vue-property-decorator'
import { BareChartOptions } from '../assets/bareChartOptions'
import TimePeriodSelect from '@/components/TimePeriodSelect.vue'
import { GetInstanceResponse, TimeScope } from '@/classes/TayehApi/Instance';
import { Instance } from '@/classes/TayehApi';

@Component({
	components: {
		TimePeriodSelect,
		apexchart: () => import('vue-apexcharts')
	},
})
export default class ShopReportSellRevenue extends Vue {
	@Inject() getInstance: () => GetInstanceResponse;
	@Prop({default: 'سود'}) title :string;
	@Prop({default: 1}) this_period: number;
	@Prop({default: 1}) last_period: number;
	
	private period: [TimeScope, number] = [TimeScope.DAY, 30];
	private total_profit = 0;
	private growth = 0;
	private series: {name: string, data: number[]}[] = [];
	private chartOptions = {
		...BareChartOptions,
		colors: ['#20ce66']
	}

	async getSalesProfitSeries (period: [TimeScope, number]) {
		let res = await Instance.getInstanceStatsSalesProfitSeries(this.getInstance().id, period[0], period[1]);
		this.series = [{
			name: 'سود فروش',
			data: res.data.series?.map(data => data.profit)
		}];
		this.total_profit = res.data.sum;
		this.growth = res.data.growth;
	}
	
	mounted () {
		this.getSalesProfitSeries(this.period)
	}
}
